import { supabase } from './supabase'

/**
 * Calcula qué número de entrega es esta en el día actual
 */
export async function calcularOrdenActual(fecha, ruta) {
  try {
    const { count } = await supabase
      .from('deliveries')
      .select('*', { count: 'exact', head: true })
      .eq('fecha', fecha)
      .eq('ruta', ruta)
    
    return (count || 0) + 1
  } catch (error) {
    console.error('Error calculando orden actual:', error)
    return 1
  }
}

/**
 * Calcula el orden promedio de un cliente basándose en entregas históricas
 */
export async function actualizarOrdenPromedio(clientId, fecha) {
  try {
    const fechaObj = new Date(fecha + 'T12:00:00')
    const diasSemana = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
    const diaActual = diasSemana[fechaObj.getDay()]
    
    console.log(`📊 Calculando orden promedio para cliente ${clientId} - ${diaActual}`)
    
    // Obtener últimas 50 entregas de este cliente
    const { data: entregas } = await supabase
      .from('deliveries')
      .select('orden_entrega, fecha, ruta')
      .eq('client_id', clientId)
      .not('orden_entrega', 'is', null)
      .order('fecha', { ascending: false })
      .limit(50)
    
    if (!entregas || entregas.length === 0) {
      console.log('⚠️ No hay entregas históricas')
      return null
    }
    
    // Filtrar solo entregas del mismo día de la semana
    const entregasMismoDia = entregas.filter(e => {
      const fechaEntrega = new Date(e.fecha + 'T12:00:00')
      const diaEntrega = diasSemana[fechaEntrega.getDay()]
      return diaEntrega === diaActual
    })
    
    if (entregasMismoDia.length === 0) {
      console.log('⚠️ No hay entregas históricas para este día de la semana')
      return null
    }
    
    // Calcular promedio
    const suma = entregasMismoDia.reduce((acc, e) => acc + e.orden_entrega, 0)
    const promedio = suma / entregasMismoDia.length
    
    console.log(`✅ Orden promedio calculado: ${promedio.toFixed(2)} (basado en ${entregasMismoDia.length} entregas)`)
    
    // Guardar en tabla de caché
    const { error } = await supabase
      .from('orden_rutas')
      .upsert({
        client_id: clientId,
        ruta: entregasMismoDia[0].ruta,
        dia_semana: diaActual,
        orden_promedio: promedio,
        total_entregas: entregasMismoDia.length,
        ultima_actualizacion: new Date().toISOString()
      }, {
        onConflict: 'client_id,dia_semana'
      })
    
    if (error) {
      console.error('Error guardando en caché:', error)
    }
    
    return promedio
  } catch (error) {
    console.error('Error actualizando orden promedio:', error)
    return null
  }
}

/**
 * Obtiene el orden aprendido para una ruta y día
 */
export async function obtenerOrdenAprendido(ruta, fecha) {
  try {
    const fechaObj = new Date(fecha + 'T12:00:00')
    const diasSemana = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
    const diaActual = diasSemana[fechaObj.getDay()]
    
    console.log(`🧠 Obteniendo orden aprendido para ruta "${ruta}" - ${diaActual}`)
    
    const { data, error } = await supabase
      .from('orden_rutas')
      .select('client_id, orden_promedio')
      .eq('ruta', ruta)
      .eq('dia_semana', diaActual)
      .order('orden_promedio', { ascending: true })
    
    if (error) {
      console.error('Error obteniendo orden:', error)
      return {}
    }
    
    // Crear un mapa client_id -> orden_promedio
    const ordenMap = {}
    data?.forEach(item => {
      ordenMap[item.client_id] = item.orden_promedio
    })
    
    console.log(`✅ Orden aprendido cargado: ${Object.keys(ordenMap).length} clientes`)
    
    return ordenMap
  } catch (error) {
    console.error('Error obteniendo orden aprendido:', error)
    return {}
  }
}